import { Dto, DtoWithId } from "@mango/core";


@Dto({fullName: "CIJBorculo.Logic.Bedrijf"})
export class Bedrijf extends DtoWithId {
	naam: string;
	pNaam: string;
	pAdres1: string;
	pAdres2: string;
	ppc: string;
	pPlaats: string;
	pTel: string;
	pFax: string;
	bNaam: string;
	bAdres1: string;
	bAdres2: string;
	bpc: string;
	bPlaats: string;
	bTel: string;
	bFax: string;
	bankRekNr: string;
	kvK: string;
	eMail: string;
	btwnr: string;
	www: string;
	opmerking: string;
	obOndertekenenNaam: string;
	obOndertekenenEmail: string;
	obBlokTekst: string;
	obFooterTekst: string;
	werkbonPrinter: string;
	pakbonPrinter: string;
	factuurPrinter: string;
	algemenePrinter: string;
	checklistSjabloon: string;
	stickerPrinter: string;
	certificaatVoorbladPrinter : string;
	certificaatVolgbladPrinter : string;
	certificaatTemplate : string;
	certificaatTemplateEnergie : string;
	certificaatSignatureName : string;
	certificaatSignatureFile : string;
	factuurTemplate : string;
	emailFactuur: string;
	emailFactuurProFormaInkoop: string;
	emailFactuurProFormaGoedkeuring: string;
	emailOproep: string;
	emailUitbesteedKlant: string;
	emailUitbesteedPrijsopgave: string;
	emailUitbesteedLeverancier: string;
	emailOrderbevestiging: string;
	onderschriftPrijsopgave: string;
	oproepMarge: number;
	grootboekrekening_Kalibraties: number;
	kostenplaats_Kalibraties: number;
	grootboekrekening_Kalibraties_EN: number;
	kostenplaats_Kalibraties_EN: number;
	documentCategory: string;
	kostenplaats_Verzendkosten: number;
	grootboekrekening_Verzendkosten: number;
	algemeneVoorwaarden: string;
	systeemTaakMail: string;
	centixRelationStatus: string;
	centixObjectStatusActief: string;
	centixObjectStatusVervallen: string;
	centixObjectType: string;
}
